// src/routes.js
import Setting from "../pages/Setting";
import Realtime from "../pages/Realtime";
import Statistics from "../pages/Statistics";
import Water from "../pages/Water";
import Users from "../pages/Users";
import Home from "../pages/Home";
import ConditionalRedirect from "../components/ConditionalRedirect";

/**
 * 定義所有路由配置
 * path      - 路由路徑
 * element   - 對應的 React 組件
 */
const routes = [
  {
    path: "/",
    element: <ConditionalRedirect />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/realtime",
    element: <Realtime />,
  },
  {
    path: "/statistics",
    element: <Statistics />,
  },
  {
    path: "/water",
    element: <Water />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/setting",
    element: <Setting />,
  },
  {
    path: "*",
    element: <ConditionalRedirect />,
  },
];

export default routes;
